var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZones(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: 400,
    height: 300,
    viewBox: "0 0 400 300",
    preserveAspectRatio: "xMidYMid meet",
    style: {
      enableBackground: "new 0 0 384.8 255.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0C263C"
    },
    d: "M20.2,121.4c0,0,2.9,6,7.1-0.1c5.6-8.2,4.5-40.1,6.5-45.1c2.1-5.4,7-12.4,17.4-6.7 s-2.6,67.5-17.7,67.7C22.5,137.3,20.2,121.4,20.2,121.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 69.5,
    y1: 1487.001,
    x2: 357.9,
    y2: 1487.001,
    gradientTransform: "matrix(1 0 0 1 0 -1362.8009)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_8_)"
    },
    d: "M347.2,22h-267c-5.9,0-10.7,4.8-10.7,10.7v183c0,5.9,4.8,10.7,10.7,10.7h272 c3.1,0,5.7-2.5,5.7-5.7V32.6C357.8,26.8,353.1,22,347.2,22z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "343.9,50.1 85.4,50.1 85.4,50.1 85.4,37.3 343.9,37.3 343.9,37.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M85.4,59.4v150.2c0,1.6,1.3,3,3,3h252.5c1.6,0,3-1.3,3-3V60.8c0-0.7-0.6-1.3-1.3-1.3L85.4,59.4 L85.4,59.4z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#494948"
    },
    d: "M338,43.7c0,1.7-1.4,3.1-3.1,3.1s-3.1-1.4-3.1-3.1c0-1.7,1.4-3.1,3.1-3.1S338,42,338,43.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000166652164313161429640000007984826346988159928_",
    gradientUnits: "userSpaceOnUse",
    x1: 53.9,
    y1: 1597.6509,
    x2: 373.7,
    y2: 1597.6509,
    gradientTransform: "matrix(1 0 0 1 0 -1362.8009)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000166652164313161429640000007984826346988159928_)"
    },
    d: "M367.9,226.4H59.7 c-3.2,0-5.8,2.5-5.8,5.7v1.3c0,5.5,4.5,9.9,10.1,9.9l303.2-0.7c5.6,0,6.5-3.8,6.5-9.2v-1.3C373.7,228.9,371.2,226.4,367.9,226.4z "
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M372.4,54.8c0,1.8-1.5,3-3,3v-0.3c0-0.3,0-0.6,0-0.6c0-0.6,0-1.8,0-2.1 C370.3,54.8,371.2,54.8,372.4,54.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000179630853979031106940000005498035324441066425_",
    gradientUnits: "userSpaceOnUse",
    x1: 41.2265,
    y1: 1445.4867,
    x2: 72.5425,
    y2: 1476.8026,
    gradientTransform: "matrix(1 0 0 1 0 -1363.415)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7DE44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4335,
    style: {
      stopColor: "#F6C145"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8647,
    style: {
      stopColor: "#F29244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000179630853979031106940000005498035324441066425_)"
    },
    d: "M70.6,85.4C67.2,85,63.2,85,59.1,86 c-2.5,0.6-4.7,1.5-4.7,1.5c-1.7,0.8-3.2,1.5-3.2,1.5c-0.3,0.6-1,1.6-2.7,2.6c-1.3,0.8-2.3,0.9-3,1c-1,0.5-3.3,2.1-4.1,4 c-0.6,1.4-0.1,2.5,0,3.3c1.1,8.9,7.8,11.6,7.8,11.6c5.8,9.3,19.7,26.8,20.5,22.7C71.7,124.3,70.6,85.4,70.6,85.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000044154313654349229870000008879025859033535137_",
    gradientUnits: "userSpaceOnUse",
    x1: 67.1939,
    y1: 1495.9452,
    x2: 65.0884,
    y2: 1515.3228,
    gradientTransform: "matrix(1 0 0 1 0 -1363.415)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000044154313654349229870000008879025859033535137_)"
    },
    d: "M61.6,127.2c-2,12.6,9,31,9,31l0.2-38.1 L61.6,127.2L61.6,127.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6BA92"
    },
    d: "M43.4,85c0.7,2.5,1.4,5.1,2.1,7.6c0.8,0,2.6-0.2,4.3-1.5c1-0.8,1.6-1.6,2-2.2c-0.8-2-1.6-4-2.4-6.1 c-2.2,0-4.3,0-6.5,0C43.1,83.5,43.2,84.2,43.4,85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F68D61"
    },
    d: "M49.8,83.2l-1.6-0.5h-0.4h-0.2l-2,1.2l-0.1,1.7c0.2,0.3,1.1,1.6,2.8,2.1c1.2,0.3,2.2,0.4,3,0.1 c-0.5-1.6-0.9-3.4-1.4-4.9L49.8,83.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6BA92"
    },
    d: "M49.8,71.4c0.5,1.1,1.4,3.6,1.6,4.2c0.2,0.8,0.4,1.1,0.6,1.9c0.8,2.7,1,2.7,1.3,4 c0.5,2.1,0.8,3.2,0.2,4.1c-0.7,0.9-2,1-4,1.1c-1.4,0.1-2.4,0.1-3.6-0.5c-1.3-0.7-2-1.8-2.3-2.3c0,0-0.1,0.8-0.7,0.5 c-0.6-0.3-2.8-3.2-1.7-3.7c1.1-0.6,2.1,0.9,2.1,0.9l0.6-1C44.1,80.5,43.5,68,49.8,71.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M51.2,81.9c0.4,1,1.5,1.5,2.5,1.1c0-0.2-0.1-0.4-0.1-0.6c-0.1-0.4-0.2-0.9-0.3-1.4L51.2,81.9 L51.2,81.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6BA92"
    },
    d: "M69.2,85.3c1.2,0,2.4,0,3.6,0c0.4,0,0.8-0.4,0.7-0.8c0-0.3-0.4-0.6-0.7-0.6l-3.6-0.4 C68.4,84.5,69.2,85.3,69.2,85.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6BA92"
    },
    d: "M68.9,87c1.2,0.1,2.3,0.1,3.4,0.2c0.5,0.1,0.9-0.3,0.9-0.7c0-0.3-0.2-0.6-0.6-0.7 c-1.2-0.2-2.3-0.3-3.5-0.5C68.3,86.1,69,87,68.9,87L68.9,87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6BA92"
    },
    d: "M68.7,88.5c1,0.1,2,0.2,3.2,0.2c0.3-0.1,0.5-0.3,0.6-0.6c0.1-0.3-0.1-0.6-0.3-0.7L68.9,87 C68.4,87.5,68.5,88.1,68.7,88.5L68.7,88.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6BA92"
    },
    d: "M69.2,83.5l3.7-0.2c0.4,0,0.6-0.3,0.6-0.7c0-0.4-0.3-0.7-0.7-0.7c-1.2,0-2.4-0.1-3.6-0.1 C68.6,82.8,69.2,83.5,69.2,83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6BA92"
    },
    d: "M71.7,128.3c-0.1-0.1-1.5-1-2.7-0.4c-0.3,0.2-0.6,0.4-0.7,0.6l-1.2-0.2l-1.1,4.9 c0.5-0.1,1-0.2,1.5-0.2c0,0.3,0.1,0.5,0.2,0.7c0.6,1,2.5,1.1,4.9,0.5C72.4,132.1,72.1,130.2,71.7,128.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F68D61"
    },
    d: "M71.7,128.3c-0.1-0.1-1.5-1-2.7-0.4l0,0c-0.1,0.8,0,1.2,0,1.2s-0.5,0.9,0.1,1.6c0,0-0.8,1.1-0.1,2.2 c0,0-0.3,0.8-0.2,1.4c0.9,0.3,2.3,0.2,3.9-0.2C72.4,132.1,72.1,130.2,71.7,128.3L71.7,128.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6BA92"
    },
    d: "M70.3,131.4l4.3-0.3c0.5-0.1,0.9-0.6,0.8-1s-0.5-0.7-1-0.7l-4.4-0.1 C69.1,130.6,70.2,131.4,70.3,131.4L70.3,131.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6BA92"
    },
    d: "M70.1,133.5c1.4,0,2.8-0.1,4.1-0.1c0.6,0,1-0.4,1-0.9c0-0.4-0.3-0.7-0.8-0.8l-4.2-0.3 C69.2,132.4,70.1,133.5,70.1,133.5L70.1,133.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6BA92"
    },
    d: "M69.9,135.3c1.2,0,2.5,0,3.9,0c0.3-0.1,0.6-0.4,0.6-0.7s-0.1-0.7-0.4-0.8c-1.3-0.1-2.6-0.1-3.9-0.2 C69.5,134.2,69.7,134.9,69.9,135.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6BA92"
    },
    d: "M70.1,129.3c1.5-0.2,2.9-0.4,4.3-0.6c0.4-0.1,0.7-0.5,0.7-0.9c0-0.5-0.4-0.8-0.9-0.8 c-1.5,0.1-2.9,0.2-4.3,0.2C69.3,128.5,70.1,129.3,70.1,129.3L70.1,129.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000129196917493163807440000017528299384201525147_",
    gradientUnits: "userSpaceOnUse",
    x1: 28.2593,
    y1: 1459.1215,
    x2: 62.0037,
    y2: 1492.8661,
    gradientTransform: "matrix(1 0 0 1 0 -1363.415)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7DE44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4335,
    style: {
      stopColor: "#F6C145"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8647,
    style: {
      stopColor: "#F29244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000129196917493163807440000017528299384201525147_)"
    },
    d: "M48.1,132.5c-5.9-3-8.6-8.3-9.5-11.2 c-2.7-8-1.6-20.1,1.3-24.1c1.5-2.1,3-3,4.3-3.8c-0.4,2.4,0.3,5.9,0.9,9.9c0.8,6.2,2.2,1.7,3.9,4.2c0.3,1.7,2,13.2,4,15.1 c1.9,1.8,12.9,4.2,14.5,4.5v7.5C65.2,135.1,52.3,134.6,48.1,132.5L48.1,132.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000174597200426274328990000013883130274279808660_",
    gradientUnits: "userSpaceOnUse",
    x1: 295.925,
    y1: 1206.0067,
    x2: 328.175,
    y2: 1238.2568,
    gradientTransform: "matrix(1 0 0 1 0 -1040.6318)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1053,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000174597200426274328990000013883130274279808660_)"
    },
    d: "M328.1,197.6h-32.2v-32.2h32.3 L328.1,197.6L328.1,197.6z M298.9,194.6h26.3v-26.2h-26.3V194.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000180354773109010430730000014306075006066691740_",
    gradientUnits: "userSpaceOnUse",
    x1: 308.4072,
    y1: 1215.989,
    x2: 316.5207,
    y2: 1224.1025,
    gradientTransform: "matrix(1 0 0 1 0 -1040.6318)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1053,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000180354773109010430730000014306075006066691740_)"
    },
    points: "311.1,189 303.1,180.7  305.3,178.7 311,184.6 319.2,175.4 321.4,177.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000178919055584266161370000001533048921134482612_",
    gradientUnits: "userSpaceOnUse",
    x1: -299.3625,
    y1: 119.8962,
    x2: -306.8885,
    y2: 113.7412,
    gradientTransform: "matrix(1 0 0 -1 418.073 298.7386)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1053,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000178919055584266161370000001533048921134482612_)"
    },
    points: "115.7,175.2 116.7,176.4  110.7,181.3 117.1,185.8 116.2,187 108.2,181.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000162345063824388389230000005844513372945829267_",
    gradientUnits: "userSpaceOnUse",
    x1: -3.3914,
    y1: 1216.7526,
    x2: -10.9175,
    y2: 1210.5974,
    gradientTransform: "matrix(-1 0 0 1 133.7621 -1033.3486)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1053,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000162345063824388389230000005844513372945829267_)"
    },
    points: "140.1,187 139.1,185.8  145.1,181 138.8,176.5 139.7,175.2 147.7,180.9  "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M131.4,173.8c-0.6-0.6-1.5-0.9-2.5-0.9c-1.1,0-2,0.3-2.7,0.8s-1.2,1.2-1.6,2s-0.6,1.7-0.8,2.7c-0.1,1-0.2,1.9-0.2,2.7 l0.1,0.1c0.6-1,1.4-1.7,2.3-2.2c0.9-0.4,2-0.7,3.1-0.7c1,0,2,0.2,2.8,0.5c0.8,0.4,1.5,0.9,2.1,1.5s1,1.4,1.3,2.2 c0.3,0.9,0.5,1.8,0.5,2.8c0,0.8-0.1,1.6-0.4,2.5c-0.2,0.9-0.6,1.6-1.2,2.3s-1.3,1.3-2.2,1.7c-0.9,0.5-2.1,0.7-3.4,0.7 c-1.6,0-2.9-0.3-3.9-1s-1.7-1.5-2.3-2.5s-0.9-2.1-1.1-3.4c-0.2-1.2-0.3-2.4-0.3-3.5c0-1.5,0.1-2.9,0.4-4.3 c0.3-1.4,0.7-2.6,1.3-3.7c0.6-1.1,1.4-1.9,2.4-2.6s2.3-1,3.8-1c1.8,0,3.2,0.5,4.3,1.4s1.7,2.3,1.8,4.1h-2.6 C132.4,175.2,132,174.4,131.4,173.8z M126.7,181.1c-0.5,0.3-1,0.6-1.4,1s-0.7,1-0.9,1.6c-0.2,0.6-0.3,1.2-0.3,1.9s0.1,1.3,0.3,1.9 c0.2,0.6,0.5,1.1,0.9,1.5s0.8,0.8,1.4,1c0.6,0.3,1.2,0.4,1.9,0.4s1.3-0.1,1.9-0.4c0.5-0.3,1-0.6,1.4-1.1c0.4-0.4,0.6-1,0.8-1.5 c0.2-0.6,0.3-1.2,0.3-1.8c0-0.7-0.1-1.3-0.3-1.9c-0.2-0.6-0.4-1.1-0.8-1.6c-0.4-0.4-0.8-0.8-1.4-1.1s-1.2-0.4-1.9-0.4 C127.9,180.7,127.3,180.8,126.7,181.1z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 109.2,
    y: 5.6,
    style: {
      fill: "#FFFFFF"
    },
    width: 211.4,
    height: 150.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "jHVoyF_00000121997240326988670360000005414913138559907250_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000029034610517096178040000005128925001844413355_",
    gradientUnits: "userSpaceOnUse",
    x1: 113.4047,
    y1: 370.6,
    x2: 316.1491,
    y2: 370.6,
    gradientTransform: "matrix(1 0 0 1 0 -338)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000029034610517096178040000005128925001844413355_)"
    },
    d: "M315.9,38.8c-2.1,0-3.9,0.1-5.8-0.1 c-0.5-0.1-1.2-1.3-1.2-2c-0.1-5.3-0.1-10.8,0-16.1c0-2-0.3-2.8-2.6-2.8c-11.4,0.1-22.9,0.1-34.3,0c-2.1,0-2.8,0.5-2.7,2.7 c0.1,5.6,0,11.3,0,16.8c0,0.8,0,1.7,0,2.7c-0.9,0-1.6,0-2.6,0c0-7.3,0-14.6,0-22.1c-14.2,0-28.1,0-42.3,0c0,6.9,0,13.7,0,20.9 c2.4,0,4.8,0,7.1,0c3.4,0,6.9,0,10.2,0.1c0.6,0,1,0.9,1.6,1.4c-0.6,0.3-1,1-1.6,1c-4.9,0.1-9.6,0-14.5,0.1c-0.8,0-1.7,0-2.9,0 c0,3.7,0,7.3,0,10.8c0,0.7,0.1,1.5-0.1,2.1c-0.1,0.5-0.8,0.8-1.4,0.8c-0.3,0-0.9-0.6-1-0.9c-0.2-0.6-0.1-1.3-0.1-1.9 c0-10.8,0-21.6,0-32.4c0-1.6-0.3-2.4-2.2-2.4c-32.3,0-64.7,0-97,0c-0.6,0-1,0.1-2.1,0.1c0,1.3,0,2.6,0,3.7c0,5,0,10,0,15 c0,1.5-0.5,2.1-2.1,2.1c-1.6-0.1-3.1,0-5,0c-0.1-1-0.1-1.9-0.1-2.7c0-7.7,0.1-15.2,0-22.9c0-2.1,0.7-2.7,2.7-2.7 c19.2,0.1,38.3,0,57.6,0c46.3,0,92.6,0,138.9,0c3.5,0,3.5,0,3.5,3.4c0,7.3,0,14.7,0,22.1C316,37,315.9,37.8,315.9,38.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000146477298801188117090000007082506446168017591_",
    gradientUnits: "userSpaceOnUse",
    x1: 217.8,
    y1: 445.0453,
    x2: 316.0412,
    y2: 445.0453,
    gradientTransform: "matrix(1 0 0 1 0 -338)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000146477298801188117090000007082506446168017591_)"
    },
    d: "M217.8,146.7c0-2.3,0-4.4,0-6.5 c0.1-0.1,0.2-0.3,0.3-0.3c3.7-0.5,3.7-0.5,3.7-4.3c0-17.9,0-35.9,0-53.8c0-0.8,0-1.7,0-2.6c1.7-0.7,2.6-0.3,2.6,1.5 c0,3,0,6,0,9.3c2.1,0,3.9-0.1,5.8,0.1c0.6,0.1,1.2,0.8,1.7,1.3c-0.6,0.5-1.2,1.2-1.9,1.2c-1.7,0.1-3.5,0-5.5,0 c-0.1,0.9-0.2,1.9-0.2,2.7c0,13.8,0,27.8,0,41.6c0,2.2,0.5,3,2.9,3c26.2-0.1,52.5-0.1,78.7,0c2.1,0,2.9-0.3,2.9-2.7 c-0.1-13.9-0.1-27.9,0-41.9c0-2.1-0.5-2.8-2.7-2.7c-11.6,0.1-23.1,0.1-34.7,0c-2,0-2.6,0.6-2.6,2.6c0.1,6.4,0.1,12.9,0,19.3 c0,0.7-0.7,1.4-1.2,2.1c-0.5-0.7-1.2-1.4-1.2-2.1c-0.1-6.2,0-12.4,0-18.6c0-3.3,0-3.3-3.4-3.3c-2.6,0-5,0-7.7,0 c0-0.9,0-1.5,0-2.4c0.9,0,1.7-0.1,2.6-0.1c15.9,0,31.7,0,47.6,0c3.3,0,3.3,0,3.3-3.3c0-5.7,0.1-11.4,0-17.1 c0-1.7,0.6-2.4,2.3-2.3c1.5,0.1,3,0,4.6,0c0,26.5,0,52.8,0,79.3C283.2,146.7,250.7,146.7,217.8,146.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000159446271047222275790000011543763674332857019_",
    gradientUnits: "userSpaceOnUse",
    x1: 113.6,
    y1: 445.1875,
    x2: 189.1,
    y2: 445.1875,
    gradientTransform: "matrix(1 0 0 1 0 -338)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000159446271047222275790000011543763674332857019_)"
    },
    d: "M189.1,140c0,2.3,0,4.5,0,6.9 c-25.2,0-50.3,0-75.5,0c0-26.4,0-52.7,0-79.4c1.9,0,3.8-0.1,5.7,0.1c0.5,0.1,1.3,1.3,1.3,2c0.1,5.1,0.1,10.3,0.1,15.4 c0,1,0,2.2,0,3.6c10.1,0,20.1,0,30.1,0c0,1,0,1.7,0,2.7c-10,0-19.9,0-30,0c-0.1,1-0.1,1.9-0.1,2.8c0,14.4,0,28.7-0.1,43.1 c0,2.3,0.7,2.9,3,2.9c18.6-0.1,37.3-0.1,55.9,0c2.2,0,3-0.6,2.9-2.9c-0.1-14.3-0.1-28.6,0-42.8c0-2.6-0.8-3.3-3.1-2.9 c-1.5,0.1-3.1,0-4.6,0c-0.7-1.9-0.2-2.7,1.6-2.6c2.1,0.1,4.2,0.1,6.2,0c1.9-0.1,2.4,0.6,2.4,2.4c-0.1,8.7,0,17.4,0,26.1 c0,6.5,0.1,13,0,19.5c-0.1,2.4,0.7,3.6,3.1,3.1C188.3,139.7,188.5,139.8,189.1,140z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000150066464383075081560000002473166108032008636_",
    gradientUnits: "userSpaceOnUse",
    x1: 124.0882,
    y1: -100.0814,
    x2: 134.9167,
    y2: -100.0814,
    gradientTransform: "matrix(1 0 0 -1 0 -68.7814)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 124.1,
    y: 20.5,
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000150066464383075081560000002473166108032008636_)"
    },
    width: 10.8,
    height: 21.6
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145020939350369509390000013790874464652374179_",
    gradientUnits: "userSpaceOnUse",
    x1: 123.972,
    y1: -100.0814,
    x2: 135.041,
    y2: -100.0814,
    gradientTransform: "matrix(1 0 0 -1 0 -68.7814)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000145020939350369509390000013790874464652374179_)"
    },
    d: "M135,42.2h-11V20.4h11V42.2z M124.2,42 h10.6V20.6h-10.6C124.2,20.6,124.2,42,124.2,42z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181783898990624284620000014888653955788199354_",
    gradientUnits: "userSpaceOnUse",
    x1: 134.9208,
    y1: -92.2814,
    x2: 143.3791,
    y2: -92.2814,
    gradientTransform: "matrix(1 0 0 -1 0 -68.7814)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 134.9,
    y: 20.5,
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000181783898990624284620000014888653955788199354_)"
    },
    width: 8.5,
    height: 6
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057130515156778407160000000483766707777113277_",
    gradientUnits: "userSpaceOnUse",
    x1: 134.8,
    y1: -92.1314,
    x2: 143.5,
    y2: -92.1314,
    gradientTransform: "matrix(1 0 0 -1 0 -68.7814)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000057130515156778407160000000483766707777113277_)"
    },
    d: "M143.5,26.5h-8.7v-6.3h8.7V26.5z  M135,26.3h8.2v-5.8H135V26.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000064344490426664447110000009706962998937460663_",
    gradientUnits: "userSpaceOnUse",
    x1: 154.7277,
    y1: -100.0814,
    x2: 165.5563,
    y2: -100.0814,
    gradientTransform: "matrix(1 0 0 -1 0 -68.7814)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 154.7,
    y: 20.5,
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000064344490426664447110000009706962998937460663_)"
    },
    width: 10.8,
    height: 21.6
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000003809626945155712240000002843446032806557837_",
    gradientUnits: "userSpaceOnUse",
    x1: 154.6075,
    y1: -100.0814,
    x2: 165.6763,
    y2: -100.0814,
    gradientTransform: "matrix(1 0 0 -1 0 -68.7814)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000003809626945155712240000002843446032806557837_)"
    },
    d: "M165.7,42.2h-11V20.4h11V42.2z  M154.9,42h10.6V20.6h-10.6V42z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000117678086379520547540000013856661578118908075_",
    gradientUnits: "userSpaceOnUse",
    x1: 165.5563,
    y1: -92.2814,
    x2: 174.0145,
    y2: -92.2814,
    gradientTransform: "matrix(1 0 0 -1 0 -68.7814)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 165.5,
    y: 20.5,
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000117678086379520547540000013856661578118908075_)"
    },
    width: 8.5,
    height: 6
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000177485956403422673900000016544606660855937706_",
    gradientUnits: "userSpaceOnUse",
    x1: 165.4284,
    y1: -92.1314,
    x2: 174.1284,
    y2: -92.1314,
    gradientTransform: "matrix(1 0 0 -1 0 -68.7814)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000177485956403422673900000016544606660855937706_)"
    },
    d: "M174.1,26.5h-8.7v-6.3h8.7V26.5z  M165.7,26.3h8.2v-5.8h-8.2V26.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062891287299586024500000003255425704220331155_",
    gradientUnits: "userSpaceOnUse",
    x1: 184.5889,
    y1: -100.0814,
    x2: 195.4175,
    y2: -100.0814,
    gradientTransform: "matrix(1 0 0 -1 0 -68.7814)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 184.6,
    y: 20.5,
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000062891287299586024500000003255425704220331155_)"
    },
    width: 10.8,
    height: 21.6
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057844723479899655080000005912679294826344100_",
    gradientUnits: "userSpaceOnUse",
    x1: 184.4728,
    y1: -100.0814,
    x2: 195.5417,
    y2: -100.0814,
    gradientTransform: "matrix(1 0 0 -1 0 -68.7814)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000057844723479899655080000005912679294826344100_)"
    },
    d: "M195.5,42.2h-11V20.4h11V42.2z  M184.7,42h10.6V20.6h-10.6V42z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000074410041758974341850000003140696729777103769_",
    gradientUnits: "userSpaceOnUse",
    x1: 195.4193,
    y1: -92.2814,
    x2: 203.8776,
    y2: -92.2814,
    gradientTransform: "matrix(1 0 0 -1 0 -68.7814)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 195.4,
    y: 20.5,
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000074410041758974341850000003140696729777103769_)"
    },
    width: 8.5,
    height: 6
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065033968680563305660000015189976339264062900_",
    gradientUnits: "userSpaceOnUse",
    x1: 195.3,
    y1: -92.1314,
    x2: 204,
    y2: -92.1314,
    gradientTransform: "matrix(1 0 0 -1 0 -68.7814)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000065033968680563305660000015189976339264062900_)"
    },
    d: "M204,26.5h-8.7v-6.3h8.7V26.5z  M195.5,26.3h8.2v-5.8h-8.2V26.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000137131595267186062190000014935090680514472094_",
    gradientUnits: "userSpaceOnUse",
    x1: -3.4275,
    y1: 757.2496,
    x2: -19.6702,
    y2: 773.4924,
    gradientTransform: "matrix(-1 0 0 1 133.3725 -689.8495)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 139.5,
    y: 64.7,
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000137131595267186062190000014935090680514472094_)"
    },
    width: 10.8,
    height: 21.6
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000069385627172624050130000014239003131967448235_",
    gradientUnits: "userSpaceOnUse",
    x1: -3.2824,
    y1: 757.1545,
    x2: -19.772,
    y2: 773.6441,
    gradientTransform: "matrix(-1 0 0 1 133.3725 -689.8495)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000069385627172624050130000014239003131967448235_)"
    },
    d: "M139.4,64.6h11v21.9h-11V64.6z  M150.2,64.8h-10.6v21.4h10.6V64.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000017501816897507175860000018315076784013720748_",
    gradientUnits: "userSpaceOnUse",
    x1: 1.7058,
    y1: 769.5662,
    x2: -5.5313,
    y2: 776.8033,
    gradientTransform: "matrix(-1 0 0 1 133.3725 -689.8495)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 131.1,
    y: 80.4,
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000017501816897507175860000018315076784013720748_)"
    },
    width: 8.5,
    height: 6
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000126304624323130172940000009706832033481980046_",
    gradientUnits: "userSpaceOnUse",
    x1: 1.9011,
    y1: 769.521,
    x2: -5.5767,
    y2: 776.9987,
    gradientTransform: "matrix(-1 0 0 1 133.3725 -689.8495)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000126304624323130172940000009706832033481980046_)"
    },
    d: "M130.9,80.3h8.7v6.3h-8.7V80.3z  M139.4,80.5h-8.2v5.8h8.2V80.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000063625394720733444730000005122978393822897341_",
    gradientUnits: "userSpaceOnUse",
    x1: -173.7388,
    y1: 767.6496,
    x2: -162.9103,
    y2: 767.6496,
    gradientTransform: "matrix(-1 0 0 1 133.3725 -689.8495)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 296.3,
    y: 67,
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000063625394720733444730000005122978393822897341_)"
    },
    width: 10.8,
    height: 21.6
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000105423002920271456980000000142385117969941669_",
    gradientUnits: "userSpaceOnUse",
    x1: -173.8591,
    y1: 767.6996,
    x2: -162.7901,
    y2: 767.6996,
    gradientTransform: "matrix(-1 0 0 1 133.3725 -689.8495)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000105423002920271456980000000142385117969941669_)"
    },
    d: "M296.2,66.9h11v21.9h-11V66.9z  M307,67.2h-10.6v21.4H307V67.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000042695488207772922040000011245068546296348039_",
    gradientUnits: "userSpaceOnUse",
    x1: -162.9103,
    y1: 775.5496,
    x2: -154.4519,
    y2: 775.5496,
    gradientTransform: "matrix(-1 0 0 1 133.3725 -689.8495)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 287.8,
    y: 82.7,
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000042695488207772922040000011245068546296348039_)"
    },
    width: 8.5,
    height: 6
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000064346691177823820330000001671730025502029245_",
    gradientUnits: "userSpaceOnUse",
    x1: -163.0275,
    y1: 775.4996,
    x2: -154.3275,
    y2: 775.4996,
    gradientTransform: "matrix(-1 0 0 1 133.3725 -689.8495)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000064346691177823820330000001671730025502029245_)"
    },
    d: "M287.7,82.5h8.7v6.3h-8.7V82.5z  M296.2,82.8H288v5.8h8.2V82.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000028299586106447432270000013536701730283546756_",
    gradientUnits: "userSpaceOnUse",
    x1: -144.3906,
    y1: 767.6496,
    x2: -133.5621,
    y2: 767.6496,
    gradientTransform: "matrix(-1 0 0 1 133.3725 -689.8495)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 266.9,
    y: 67,
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000028299586106447432270000013536701730283546756_)"
    },
    width: 10.8,
    height: 21.6
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000155861894086916221520000000906547835029345976_",
    gradientUnits: "userSpaceOnUse",
    x1: -144.5109,
    y1: 767.6996,
    x2: -133.4419,
    y2: 767.6996,
    gradientTransform: "matrix(-1 0 0 1 133.3725 -689.8495)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000155861894086916221520000000906547835029345976_)"
    },
    d: "M266.8,66.9h11v21.9h-11V66.9z  M277.6,67.2H267v21.4h10.6V67.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000176738964894091519350000017059580170865148603_",
    gradientUnits: "userSpaceOnUse",
    x1: -133.5621,
    y1: 775.5496,
    x2: -125.1037,
    y2: 775.5496,
    gradientTransform: "matrix(-1 0 0 1 133.3725 -689.8495)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 258.4,
    y: 82.7,
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000176738964894091519350000017059580170865148603_)"
    },
    width: 8.5,
    height: 6
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000023975482009134610440000010654899431420273281_",
    gradientUnits: "userSpaceOnUse",
    x1: -133.6823,
    y1: 775.4996,
    x2: -124.9823,
    y2: 775.4996,
    gradientTransform: "matrix(-1 0 0 1 133.3725 -689.8495)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000023975482009134610440000010654899431420273281_)"
    },
    d: "M258.3,82.5h8.7v6.3h-8.7V82.5z  M266.8,82.8h-8.2v5.8h8.2V82.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000083790345790663483840000010372641871451507875_",
    gradientUnits: "userSpaceOnUse",
    x1: -109.8935,
    y1: 819.1496,
    x2: -99.0651,
    y2: 819.1496,
    gradientTransform: "matrix(-1 0 0 1 133.3725 -689.8495)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 232.4,
    y: 118.5,
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000083790345790663483840000010372641871451507875_)"
    },
    width: 10.8,
    height: 21.6
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039117484954890564210000008560533079100583347_",
    gradientUnits: "userSpaceOnUse",
    x1: -110.0138,
    y1: 819.1996,
    x2: -98.9449,
    y2: 819.1996,
    gradientTransform: "matrix(-1 0 0 1 133.3725 -689.8495)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000039117484954890564210000008560533079100583347_)"
    },
    d: "M232.3,118.4h11v21.9h-11V118.4z  M243.1,118.6h-10.6V140h10.6V118.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000171708250180599439400000011372422841558582423_",
    gradientUnits: "userSpaceOnUse",
    x1: -99.0596,
    y1: 827.0496,
    x2: -90.6012,
    y2: 827.0496,
    gradientTransform: "matrix(-1 0 0 1 133.3725 -689.8495)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 134.2,
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000171708250180599439400000011372422841558582423_)"
    },
    width: 8.5,
    height: 6
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065046567379821797140000010036103159859791503_",
    gradientUnits: "userSpaceOnUse",
    x1: -99.1852,
    y1: 826.9996,
    x2: -90.4852,
    y2: 826.9996,
    gradientTransform: "matrix(-1 0 0 1 133.3725 -689.8495)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000065046567379821797140000010036103159859791503_)"
    },
    d: "M223.8,134h8.7v6.3h-8.7V134z  M232.3,134.3h-8.2v5.8h8.2V134.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000104664167900976199680000002066289914843880850_",
    gradientUnits: "userSpaceOnUse",
    x1: -529.6744,
    y1: 182.1862,
    x2: -518.8458,
    y2: 182.1862,
    gradientTransform: "matrix(1.836970e-16 -1 -1 -1.836970e-16 480.0862 -492.6448)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 287.1,
    y: 26.2,
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000104664167900976199680000002066289914843880850_)"
    },
    width: 21.6,
    height: 10.8
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021115386267403978550000014714967152229984657_",
    gradientUnits: "userSpaceOnUse",
    x1: -529.7947,
    y1: 182.0862,
    x2: -518.7257,
    y2: 182.0862,
    gradientTransform: "matrix(1.836970e-16 -1 -1 -1.836970e-16 480.0862 -492.6448)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000021115386267403978550000014714967152229984657_)"
    },
    d: "M309,26v11h-22V26H309z M308.7,37V26.4 h-21.4V37H308.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000038410214234704899700000009707154411139951524_",
    gradientUnits: "userSpaceOnUse",
    x1: -16.9597,
    y1: -124.0521,
    x2: -6.1312,
    y2: -124.0521,
    gradientTransform: "matrix(-1 0 0 -1 133.3725 -20.4521)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 139.5,
    y: 92.8,
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000038410214234704899700000009707154411139951524_)"
    },
    width: 10.8,
    height: 21.6
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000108269523597532432410000000216870033476403849_",
    gradientUnits: "userSpaceOnUse",
    x1: -17.0759,
    y1: -124.0021,
    x2: -6.007,
    y2: -124.0021,
    gradientTransform: "matrix(-1 0 0 -1 133.3725 -20.4521)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000108269523597532432410000000216870033476403849_)"
    },
    d: "M139.4,92.6h11v21.9h-11V92.6z  M150.2,92.9h-10.6v21.4h10.6V92.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000126316496254224235210000008700867298350937524_",
    gradientUnits: "userSpaceOnUse",
    x1: -6.129,
    y1: -116.2521,
    x2: 2.3293,
    y2: -116.2521,
    gradientTransform: "matrix(-1 0 0 -1 133.3725 -20.4521)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 131.1,
    y: 92.8,
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000126316496254224235210000008700867298350937524_)"
    },
    width: 8.5,
    height: 6
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000060030486957965436240000012845916224109551767_",
    gradientUnits: "userSpaceOnUse",
    x1: -6.2493,
    y1: -116.2021,
    x2: 2.4507,
    y2: -116.2021,
    gradientTransform: "matrix(-1 0 0 -1 133.3725 -20.4521)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000060030486957965436240000012845916224109551767_)"
    },
    d: "M130.9,92.6h8.7v6.3h-8.7V92.6z  M139.4,92.9h-8.2v5.8h8.2V92.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103251418749858514810000008893013945717316522_",
    gradientUnits: "userSpaceOnUse",
    x1: 496.2828,
    y1: 276.0924,
    x2: 507.1114,
    y2: 276.0924,
    gradientTransform: "matrix(1.836970e-16 1 -1 1.836970e-16 407.5924 -375.9464)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 120.7,
    y: 120.3,
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000103251418749858514810000008893013945717316522_)"
    },
    width: 21.6,
    height: 10.8
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000107553223993803679220000007190063670150060215_",
    gradientUnits: "userSpaceOnUse",
    x1: 496.1667,
    y1: 276.0424,
    x2: 507.2355,
    y2: 276.0424,
    gradientTransform: "matrix(1.836970e-16 1 -1 1.836970e-16 407.5924 -375.9464)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000107553223993803679220000007190063670150060215_)"
    },
    d: "M120.6,131.3v-11h21.9v11H120.6z  M120.8,120.5V131h21.4v-10.6L120.8,120.5L120.8,120.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000120530932078957986160000011408897502808822693_",
    gradientUnits: "userSpaceOnUse",
    x1: 507.1078,
    y1: 283.8924,
    x2: 515.5661,
    y2: 283.8924,
    gradientTransform: "matrix(1.836970e-16 1 -1 1.836970e-16 407.5924 -375.9464)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 120.7,
    y: 131.1,
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000120530932078957986160000011408897502808822693_)"
    },
    width: 6,
    height: 8.5
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000023974198014700993010000011168003443106973327_",
    gradientUnits: "userSpaceOnUse",
    x1: 506.9875,
    y1: 283.8424,
    x2: 515.6875,
    y2: 283.8424,
    gradientTransform: "matrix(1.836970e-16 1 -1 1.836970e-16 407.5924 -375.9464)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000023974198014700993010000011168003443106973327_)"
    },
    d: "M120.6,139.7V131h6.3v8.7H120.6z  M120.8,131.3v8.2h5.8v-8.2H120.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111875354264491785060000018192378837300308908_",
    gradientUnits: "userSpaceOnUse",
    x1: 496.2828,
    y1: 241.5924,
    x2: 507.1114,
    y2: 241.5924,
    gradientTransform: "matrix(1.836970e-16 1 -1 1.836970e-16 407.5924 -375.9464)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 155.2,
    y: 120.3,
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000111875354264491785060000018192378837300308908_)"
    },
    width: 21.6,
    height: 10.8
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000143614887598106391610000002955165745707186577_",
    gradientUnits: "userSpaceOnUse",
    x1: 496.1667,
    y1: 241.5424,
    x2: 507.2355,
    y2: 241.5424,
    gradientTransform: "matrix(1.836970e-16 1 -1 1.836970e-16 407.5924 -375.9464)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000143614887598106391610000002955165745707186577_)"
    },
    d: "M155.1,131.3v-11H177v11H155.1z  M155.3,120.5V131h21.5v-10.6L155.3,120.5L155.3,120.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000150792803239095109560000002054095881180650427_",
    gradientUnits: "userSpaceOnUse",
    x1: 507.1078,
    y1: 249.3924,
    x2: 515.5661,
    y2: 249.3924,
    gradientTransform: "matrix(1.836970e-16 1 -1 1.836970e-16 407.5924 -375.9464)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 155.2,
    y: 131.1,
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000150792803239095109560000002054095881180650427_)"
    },
    width: 6,
    height: 8.5
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000177450560460549950820000004118838755475962783_",
    gradientUnits: "userSpaceOnUse",
    x1: 506.9875,
    y1: 249.3424,
    x2: 515.6875,
    y2: 249.3424,
    gradientTransform: "matrix(1.836970e-16 1 -1 1.836970e-16 407.5924 -375.9464)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000177450560460549950820000004118838755475962783_)"
    },
    d: "M155.1,139.7V131h6.3v8.7H155.1z  M155.3,131.3v8.2h5.8v-8.2H155.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000170260125746924509860000006065820005347217304_",
    gradientUnits: "userSpaceOnUse",
    x1: -404.0707,
    y1: 389.7224,
    x2: -393.2423,
    y2: 389.7224,
    gradientTransform: "matrix(-1.836970e-16 -1 1 -1.836970e-16 -91.3224 -288.908)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 287.6,
    y: 104.3,
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000170260125746924509860000006065820005347217304_)"
    },
    width: 21.6,
    height: 10.8
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000167364073204551937950000013080392271058972575_",
    gradientUnits: "userSpaceOnUse",
    x1: -404.191,
    y1: 389.6724,
    x2: -393.1221,
    y2: 389.6724,
    gradientTransform: "matrix(-1.836970e-16 -1 1 -1.836970e-16 -91.3224 -288.908)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000167364073204551937950000013080392271058972575_)"
    },
    d: "M309.3,104.2v11h-21.9v-11H309.3z  M309.1,115v-10.6h-21.4V115H309.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000162325388476721271930000005473483480054149555_",
    gradientUnits: "userSpaceOnUse",
    x1: -393.2423,
    y1: 397.5224,
    x2: -384.7839,
    y2: 397.5224,
    gradientTransform: "matrix(-1.836970e-16 -1 1 -1.836970e-16 -91.3224 -288.908)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 303.2,
    y: 95.8,
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000162325388476721271930000005473483480054149555_)"
    },
    width: 6,
    height: 8.5
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000135652619444471110910000001067830481844023222_",
    gradientUnits: "userSpaceOnUse",
    x1: -393.3626,
    y1: 397.4724,
    x2: -384.6626,
    y2: 397.4724,
    gradientTransform: "matrix(-1.836970e-16 -1 1 -1.836970e-16 -91.3224 -288.908)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000135652619444471110910000001067830481844023222_)"
    },
    d: "M309.3,95.7v8.7H303v-8.7H309.3z  M309.1,104.2V96h-5.8v8.2H309.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088103544158714372730000008699360883741546368_",
    gradientUnits: "userSpaceOnUse",
    x1: 256.3727,
    y1: -171.4814,
    x2: 264.7633,
    y2: -171.4814,
    gradientTransform: "matrix(1 0 0 -1 0 -68.7814)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 256.4,
    y: 94.4,
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000088103544158714372730000008699360883741546368_)"
    },
    width: 8.4,
    height: 16.6
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000020371917549425997540000010639740536515374471_",
    gradientUnits: "userSpaceOnUse",
    x1: 256.2795,
    y1: -171.5314,
    x2: 264.8564,
    y2: -171.5314,
    gradientTransform: "matrix(1 0 0 -1 0 -68.7814)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000020371917549425997540000010639740536515374471_)"
    },
    d: "M264.8,111.2h-8.6V94.3h8.6V111.2z  M256.5,110.9h8.2V94.4h-8.2V110.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000104704689298223527780000010053001791891144586_",
    gradientUnits: "userSpaceOnUse",
    x1: 270.6607,
    y1: -171.6814,
    x2: 279.0512,
    y2: -171.6814,
    gradientTransform: "matrix(1 0 0 -1 0 -68.7814)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 270.6,
    y: 94.6,
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000104704689298223527780000010053001791891144586_)"
    },
    width: 8.4,
    height: 16.6
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000045616060105478106450000002055530819007819655_",
    gradientUnits: "userSpaceOnUse",
    x1: 270.5674,
    y1: -171.6314,
    x2: 279.1444,
    y2: -171.6314,
    gradientTransform: "matrix(1 0 0 -1 0 -68.7814)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000045616060105478106450000002055530819007819655_)"
    },
    d: "M279.1,111.3h-8.6V94.4h8.6V111.3z  M270.8,111.2h8.2V94.7h-8.2V111.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000136407800161115322290000017947673137456348550_",
    gradientUnits: "userSpaceOnUse",
    x1: 270.6607,
    y1: -96.9814,
    x2: 279.0512,
    y2: -96.9814,
    gradientTransform: "matrix(1 0 0 -1 0 -68.7814)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 270.6,
    y: 19.9,
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000136407800161115322290000017947673137456348550_)"
    },
    width: 8.4,
    height: 16.6
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000141425522794942710640000001147898445934541200_",
    gradientUnits: "userSpaceOnUse",
    x1: 270.5674,
    y1: -96.9814,
    x2: 279.1444,
    y2: -96.9814,
    gradientTransform: "matrix(1 0 0 -1 0 -68.7814)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000141425522794942710640000001147898445934541200_)"
    },
    d: "M279.1,36.6h-8.6V19.8h8.6V36.6z  M270.8,36.4h8.2V20h-8.2V36.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000170249672905102866170000008705119850014082229_",
    gradientUnits: "userSpaceOnUse",
    x1: 226,
    y1: -117.2814,
    x2: 242.6,
    y2: -117.2814,
    gradientTransform: "matrix(1 0 0 -1 0 -68.7814)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 44.3,
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000170249672905102866170000008705119850014082229_)"
    },
    width: 16.6,
    height: 8.4
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000072256145591901601300000005950635613441853058_",
    gradientUnits: "userSpaceOnUse",
    x1: 225.9,
    y1: -117.2814,
    x2: 242.7,
    y2: -117.2814,
    gradientTransform: "matrix(1 0 0 -1 0 -68.7814)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000072256145591901601300000005950635613441853058_)"
    },
    d: "M225.9,52.8v-8.6h16.8v8.6 C242.7,52.8,225.9,52.8,225.9,52.8z M226,44.4v8.2h16.5v-8.2H226z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026852037067740411040000006047604593927393215_",
    gradientUnits: "userSpaceOnUse",
    x1: -298.3284,
    y1: 291.654,
    x2: -281.7284,
    y2: 291.654,
    gradientTransform: "matrix(6.123234e-17 -1 -1 -6.123234e-17 471.154 -211.4284)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 175.3,
    y: 70.3,
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000026852037067740411040000006047604593927393215_)"
    },
    width: 8.4,
    height: 16.6
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000182520503443812083840000003800833566162880919_",
    gradientUnits: "userSpaceOnUse",
    x1: -298.4284,
    y1: 291.654,
    x2: -281.6284,
    y2: 291.654,
    gradientTransform: "matrix(6.123234e-17 -1 -1 -6.123234e-17 471.154 -211.4284)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000182520503443812083840000003800833566162880919_)"
    },
    d: "M183.8,87h-8.6V70.2h8.6V87z  M175.4,86.8h8.2V70.3h-8.2V86.8z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZones);
export default __webpack_public_path__ + "static/media/zones.8eee9285.svg";
export { ForwardRef as ReactComponent };